import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import {Choisir} from "./Choisir"
import {Modal} from "../question/Modal"
import {clean, affiche_param} from "../Fonctions"
import {tab_color_bg, tab_color_btn} from "../config/Config"
import {Etiquette} from "./Etiquette"
import {pluriel} from "../Fonctions"

import './Devoirs.css';

export function Devoirs_alea ({auth, updateUser}) {

  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  const [show_activite, setShow_activite] = useState(false)
  
  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
  const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)

  const [devoir_cree, setDevoir_cree] = useState({
    classe:'',
    nb_question:'3',
    etoile:'',
    niveau:'',
    titre:'',
    titre_active:false,
    comm_active:'',
    info_diff:false,
    champ_valid:true,
    optionnel:'Non',
    date_limit:'Non',
    date_limit_value:today,
    notion:[],
    selection:{},
    search:'',
    config_supp:'',
    config_supp_active:false,
    mode_aleatoire:true,
    replayable:'∞',
    nbEssaisMin:1,
    etape:1,
  })
  const cleanDevoir_cree = (param) => {
    setDevoir_cree({...devoir_cree, titre:'', titre_active:false, comm_active:'', niveau:'', nb_question:'3', etoile:'⭐', notion:[], selection:{}, config_supp_active:param === 'supprMesquestions', nbEssaisMin:1, etape:1})

    //setModifTitre({activ:false,num:0})
    //setResend({activ:false,num:''})
  }
  
  /*const [modifTitre, setModifTitre] = useState({
      activ:false,
      num:0
    })

  const [resend, setResend] = useState({
      activ:false,
      num:''
    })*/

  const [diff, setDiff] = useState({
    niv1:user.diff.niv1,
    niv2:user.diff.niv2,
    niv3:user.diff.niv3
  })
  const [msg, setMsg] = useState({
    diff_maj:'',
  })

  const cleanMsg = (name) => {
    setTimeout(e => {
          setMsg({...msg, [name]:''})
        }, 3000)
  }

  const handleChange = (e) => {
    const name = e.target.attributes.name.nodeValue
    //setDevoir_cree({...devoir_cree, [name]:e.target.value})
    if(devoir_cree.titre.includes('&')||devoir_cree.titre.includes('\\')||devoir_cree.titre.includes('<')||devoir_cree.titre.includes('>')||devoir_cree.titre.includes('"') 
      || devoir_cree.comm_active.includes('&')||devoir_cree.comm_active.includes('\\')||devoir_cree.comm_active.includes('<')||devoir_cree.comm_active.includes('>')||devoir_cree.comm_active.includes('"')
      ||e.target.value.includes('&')||e.target.value.includes('\\')||e.target.value.includes('<')||e.target.value.includes('>')||e.target.value.includes('"')){
      setMsg({alert_titre:'<div class="alert danger"><br>Vous ne pouvez pas utiliser de caractères <br> spéciaux tels que &, \\, \', <, > ou " !<br><br></div>'})
      setDevoir_cree({...devoir_cree, [name]:e.target.value, champ_valid:false})
    } else {
      setMsg({alert_titre:''})
      setDevoir_cree({...devoir_cree, [name]:e.target.value, champ_valid:true})
    }
  }

  const handleClick = (e) => {
    let name = e.target.attributes.name.nodeValue
    let field = name === 'date_limit_value' ? e.target.value : e.target.innerText
    
    if (field === 'Non' && 'optionnel_date_limit'.includes(name)) {field = 'Oui'}
    else if (field === 'Oui' && 'optionnel_date_limit'.includes(name)) {field = 'Non'}
    if (name === 'etoile' && field === devoir_cree.etoile) {field=''}
    if(e.target.className.includes('btn_param') ||'date_limit_value_etoile_soustitre_config_supp'.includes(name)) {
      let etape = devoir_cree.etape === 1 ? 2 : devoir_cree.etape
      setDevoir_cree({...devoir_cree, [name]:field, etape})
    }
    if(name === 'config_supp_active'){
      if(devoir_cree.config_supp_active){
        field = false
        e.target.innerText = '+'
      } else {
        field = true
        e.target.innerText = '−'
      }
      setDevoir_cree({...devoir_cree, config_supp:'Choisir des questions', [name]:field})
    }
    if(name === 'niveau'){
      setDevoir_cree({...devoir_cree, search:'', niveau:(devoir_cree.niveau !== field.trim()) && field.trim(), selection:{}, etape:3})
    }
    if(name==="modif_titre") {
      if(devoir_cree.notion[0].includes('/')){
        setDevoir_cree({...devoir_cree, titre:devoir_cree.notion[0].split('/')[1]})
      } else {
        setDevoir_cree({...devoir_cree, titre:devoir_cree.notion[0]})
      }
    }
    if(name==="info_diff") {setDevoir_cree({...devoir_cree, info_diff:!devoir_cree.info_diff})}
    if(name==="mode_aleatoire") {setDevoir_cree({...devoir_cree, mode_aleatoire:!devoir_cree.mode_aleatoire, replayable:!devoir_cree.mode_aleatoire ? '∞' : '1', nbEssaisMin:1})}
    if(e.target.className === 'teal'){
      e.target.className = 'chocolate'
      setDiff({...diff, niv1:diff.niv1?.replace(e.target.id+'__', ''), niv2:diff.niv2+e.target.id+'__'})
    }
    else if(e.target.className === 'chocolate'){
      e.target.className = 'purple'
      setDiff({...diff, niv2:diff.niv2?.replace(e.target.id+'__', ''), niv3:diff.niv3+e.target.id+'__'})
    }
    else if(e.target.className === 'purple'){
      e.target.className = 'teal'
      setDiff({...diff, niv3:diff.niv3?.replace(e.target.id+'__', ''), niv1:diff.niv1+e.target.id+'__'})
    }
  }

  const handleClickTitre = (e) => {
    let field = e.target.innerText
    let selection = {}
    let tab_notion = devoir_cree.notion
    
    if(!e.target.title){
      if(devoir_cree.selection[field] && devoir_cree.selection[field].length === 0){
        selection = devoir_cree.selection
        delete selection[field]
        tab_notion = tab_notion.filter(elt => elt !== field)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      } else {
        selection = {...devoir_cree.selection, [field]:[]}
        tab_notion = tab_notion.filter(elt => !elt.includes(field) )
        tab_notion.push(field)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      }
    } else {
      const titre = e.target.title.split('/')[0]
      tab_notion = tab_notion.filter(elt=> elt !== titre)
      //const soustitre = e.target.title.split('/')[1]

      if(!devoir_cree.selection[titre]) {
        const selection = {...devoir_cree.selection, [titre]:[field]}
        tab_notion.push(e.target.title)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      } else {
        const tab = devoir_cree.selection[titre]

        if(!tab.includes(field)){
          tab.push(field)
          tab_notion.push(e.target.title)
          const selection = {...devoir_cree.selection, [titre]:tab}
          setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
        }
        else {
          tab_notion = tab_notion.filter(elt =>elt!==e.target.title)
          const index = tab.indexOf(field)
          tab.splice(index, 1)
          if(tab.length === 0){
            selection = devoir_cree.selection
            delete selection[titre]
          } else {
            selection = {...devoir_cree.selection, [titre]:tab}
          }
          setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
          
        }
      }
    }
  }

  const sendData = (auth, name) => {
    //console.log(auth)
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      setMsg({...msg, [name]:data})
      cleanMsg(name)
      updateUsercontext()
      //updateUser()
      cleanDevoir_cree()
    })
    .catch(err => console.log(err))
  }
  const joinObj = (obj) => {
    let result = ''
    Object.keys(obj).forEach(e => {
      result += devoir_cree.selection[e]?.length > 0 ? (devoir_cree.selection[e]?.length === 1 ? '__'+e+'/'+devoir_cree.selection[e] : '__'+e+'/'+devoir_cree.selection[e].join('__'+e+'/')) : (result ? '__'+e : e)
    })
    if(result.slice(-2) === '__') {result = result.slice(0,-2)}
    if(result.slice(0,2) === '__') {result = result.slice(2,result.length)}
    return result
  }
  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    if (!devoir_cree.champ_valid){
      setMsg({devoir_send:'<div class="alert danger"><br>Le devoir n\'a pas été envoyé.<br>Le titre (ou la consigne) n\'est pas valide...<br><br></div>'})
      return
    }
    switch (name) {
      case 'diff_maj':
        if(!diff.niv1 && !diff.niv2 && ! diff.niv3) {
          setMsg({...msg,action:name, diff_maj:'<div class="alert danger fadeout5"><br>Veuillez modifier au moins un niveau d\'élève. <br><br>'})
          cleanMsg('diff_maj')
        } else {
            auth = {...auth, action:name, field:[diff.niv1, diff.niv2, diff.niv3], diff_sql:user.diff}
            sendData(auth, name)
        }
        break;
      case 'devoir_send':
        auth = {...auth, action:name, field:[devoir_cree.niveau, devoir_cree.nb_question, devoir_cree.etoile==='' ? '0' : devoir_cree.etoile , joinObj(devoir_cree.selection) , devoir_cree.classe, devoir_cree.optionnel==='Non', devoir_cree.titre, devoir_cree.date_limit==='Oui' ? devoir_cree.date_limit_value:'', devoir_cree.comm_active], replayable:'1', nbEssaisMin:devoir_cree.nbEssaisMin}
        sendData(auth, name)
        break;
      default:
        console.log('default')
    }
  }
  /*const moyenne = (eleves) => {
    let moy = 0
    let nb_question = 0
    eleves?.forEach(e => {
      moy = moy + e.note*e.nb_question
      nb_question = nb_question + e.nb_question*1
    })
    return Math.round(moy*10/nb_question)/10
  }*/
  const diff_niv = (eleve) => {
    if (user.diff?.niv2?.includes(eleve.id)) {return "chocolate"}
    if (user.diff?.niv3?.includes(eleve.id)) {return "purple"}
    else {return "teal"}
  }

  let color_devoir = {}
  let color_btn = {}

  let k = 0
  user.liste_classes?.forEach(c => {
    color_devoir = {...color_devoir, [c]:tab_color_bg[k]}
    color_btn = {...color_btn, [c]:tab_color_btn[k]}
    k++
  })

  //console.log(user)
  //console.log(devoir_cree.nbEssaisMin)
  //console.log(devoir_cree.optionnel)
  //console.log('To Modal', {...auth, profil:user.profil, notion:devoir_cree.notion, nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile ? devoir_cree.etoile.length : '0', activite:devoir_cree.notion.join('__'), niveau:devoir_cree.niveau})
  return (
    <div>
      {user.liste_classes.length ?
      <>
    	<div className="content max" style={{textAlign:"left"}} >
       <h1>Donner un devoir</h1>

       {devoir_cree.classe && <span className="btn_param" onClick={()=>setDevoir_cree({...devoir_cree, selection:{}, notion:[], mode_aleatoire:true, titre:'', titre_active:false, comm_active:'', niveau:'', etape:1})} style={{borderColor: devoir_cree.etape === 1 ? color_btn[devoir_cree.classe] : 'rgb(49, 65, 89, 0.3)', backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe]}}>▸ Classes / Niveau scolaire</span>}
       {devoir_cree.etape > 1 && <span className="btn_param" onClick={()=>setDevoir_cree({...devoir_cree, mode_aleatoire:true, etape:3})} style={{borderColor: devoir_cree.etape === 3 ? color_btn[devoir_cree.classe] : 'rgb(49, 65, 89, 0.3)', backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe]}}>▸ Thèmes</span>}
       {Object.keys(devoir_cree.selection).length !== 0 && <>
            
            <span className="btn_param" onClick={()=>setDevoir_cree({...devoir_cree, etape:4})} style={{borderColor: devoir_cree.etape === 4 ? color_btn[devoir_cree.classe] : 'rgb(49, 65, 89, 0.3)', backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe]}}>▸ Paramètres suppl</span>
            <span className="btn_param" onClick={()=>setDevoir_cree({...devoir_cree, etape:5})} style={{borderColor: devoir_cree.etape === 5 ? color_btn[devoir_cree.classe] : 'rgb(49, 65, 89, 0.3)', backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe]}}>▸ Mode</span>
          </>}

       {devoir_cree.etape === 1 && <span>
            <br/><br/>
            <b style={{color:color_btn[devoir_cree.classe]}}>▸ Choisir une classe et un niveau scolaire :</b><br/><br/> 
            Mes classes : <br/>
            {affiche_param(user.liste_classes, devoir_cree.classe, 'classe', (e)=>setDevoir_cree({...devoir_cree, classe:e.target.innerText,etape:devoir_cree.niveau ? 3 : 1}))}
            <br/> 
            <br/> 
            Niveau scolaire : <br/>
            {Object.keys(user.liste_activites_all).map((niv, k_niv) => <span key={k_niv} className={"btn_param niveau"+(niv === devoir_cree.niveau ? ' active' : '')} name="niveau" onClick={(e)=>setDevoir_cree({...devoir_cree, niveau:e.target.innerText,etape:devoir_cree.classe ? 3 : 1})}>{niv}</span>)}
        </span>}

       {
        devoir_cree.etape === 3 && <div className="cadre_notion active"> 
          <b style={{color:color_btn[devoir_cree.classe]}}>▸ Choisir un ou plusieurs thèmes de {devoir_cree.niveau} :</b> &nbsp;
          <input name="search" type="text" className="recherche_rapide" placeholder="Recherche rapide" onChange={handleChange} />
          <div className={'cadre_liste_notion' + (devoir_cree.search && ' col1')} >
                {Object.keys(user.liste_activites_all[devoir_cree.niveau]).map((titre, kt) => 
                  <span key={kt}>
                    {clean(titre).includes(clean(devoir_cree.search)) && <div>
                                        <b name="titre" className={'devoir_titre'+(Object.keys(devoir_cree.selection).includes(titre) && (devoir_cree.selection[titre] && devoir_cree.selection[titre].length === 0) ? ' active' :'')} onClick={handleClickTitre}>{titre}</b>
                                      </div>}
                    {Object.values(user.liste_activites_all[devoir_cree.niveau][titre]).map((soustitre,ks) => 
                        (clean(titre).includes(clean(devoir_cree.search)) || clean(soustitre).includes(clean(devoir_cree.search))) && <div key={ks} title={titre+'/'+soustitre} name="soustitre" className={'devoir_titre'+(devoir_cree.selection[titre]?.includes(soustitre) ? ' active' :'')} onClick={handleClickTitre} >{ soustitre }
                          </div>
                      )}
                    {(clean(titre).includes(clean(devoir_cree.search))) && <br/>}
                  </span>
                )}
              </div>
              
        </div>
      }
       
      <div name="notions">
      </div>
      {   /*  ======================  
                  Mode du devoir  
              ======================
          */
        devoir_cree.etape === 5 && <span> 
       <b style={{color:color_btn[devoir_cree.classe]}}>▸ Choisir un mode pour ce devoir :</b> {/*affiche_param(['Questions aléatoires', 'Questions choisies'], devoir_cree.mode_aleatoire, 'mode_aleatoire', handleClick)*/}
       <span className={'btn_param' + (devoir_cree.mode_aleatoire ? ' active' : '')} name="mode_aleatoire" onClick={handleClick}>Questions aléatoires</span>
       <span className={'btn_param' + (!devoir_cree.mode_aleatoire ? ' active' : '')} name="mode_aleatoire" onClick={handleClick}>Questions choisies</span>
       <br/>
       {
        devoir_cree.mode_aleatoire && <span>          
            Nombre de questions : 
            <input type="range" name="nb_question" min="1" max="10" defaultValue={3} onChange={(e)=>setDevoir_cree({...devoir_cree, nb_question:e.target.value})}/> <span className="btn_param active">{devoir_cree.nb_question} question{pluriel(devoir_cree.nb_question)}</span>
            <br/>
            Difficulté : {affiche_param(['⭐', '⭐⭐', '⭐⭐⭐', '🅳'], devoir_cree.etoile, 'etoile', handleClick)}
            <br/>
            <span title="Le devoir ne sera pris en compte (sinon 0) qu'à partir d'un nombre de tentatives égal à votre choix, et le score sera la moyenne des scores des séries réalisées. Ensuite, la moyenne n'évoluera que si l'élève obtient un score supérieur à sa moyenne précédente.">Nombre d'essais minimum : <input type="range" name="nbEssaisMin" min="1" max="10" defaultValue={devoir_cree.nbEssaisMin} onChange={handleChange} /> <span className="btn_param active">{devoir_cree.nbEssaisMin}</span></span>
        </span>
       }

       {
        !devoir_cree.mode_aleatoire && <>Nombre d'essais : {affiche_param(['1','∞'], devoir_cree.replayable, 'replayable', (e)=>{
                  setDevoir_cree({...devoir_cree, replayable:e.target.innerText})
                })}</>
       }
       </span>
      }
       {  /*  =============================  
                Paramètres supplémentaires  
              =============================
          */
        devoir_cree.etape === 4 && <span><br/>
          <b style={{color:color_btn[devoir_cree.classe]}}> ▸ Paramètres supplémentaires :</b> <br/><br/>
          Titre : <input name="titre" placeholder="Titre du devoir" onChange={handleChange} value={devoir_cree.titre} />&nbsp;&nbsp;
                  <span name="modif_titre" style={{cursor:'pointer'}} onClick={handleClick}>🖊</span>
          <br/>
          Consigne : <input name="comm_active" style={{margin:'10px 0px 5px 0px'}} placeholder="Ajouter une consigne" onChange={handleChange} />
          <br/>
           <span title={"La demande de faire le devoir ne sera pas supprimée automatiquement à cette date, le professeur garde la main pour le faire."}>Indiquer une date limite ?  {affiche_param(['Oui', 'Non'], devoir_cree.date_limit, 'date_limit', ()=>devoir_cree.date_limit === 'Oui' ? setDevoir_cree({...devoir_cree, date_limit:'Non'}) : setDevoir_cree({...devoir_cree, date_limit:'Oui'}))}</span>
           {devoir_cree.date_limit === 'Oui' ? <input type="date" name="date_limit_value" value={devoir_cree.date_limit_value} min={today} onClick={handleClick} onChange={handleChange} /> : ''}
           <br/>
           <span title={"Un devoir optionnel n'amène pas le score de 0 % lorsque l'élève ne le réalise pas et que de le(la) professeur supprime la demande de faire ce devoir.  \u000dCette option permet de différencier en quantité, mais peut aussi être utilisée pour différencier les devoirs par notions."}>Devoir optionnel ? {affiche_param(['Oui', 'Non'], devoir_cree.optionnel, 'optionnel', ()=>devoir_cree.optionnel === 'Oui' ? setDevoir_cree({...devoir_cree, optionnel:'Non'}) : setDevoir_cree({...devoir_cree, optionnel:'Oui'}))}</span>
           
           <br/>
         </span>
       }

      {
        Object.keys(devoir_cree.selection).length && !devoir_cree.mode_aleatoire && devoir_cree.etape !== 4 ? <div className="choix_questions" style={{textAlign:"left", minHeight:'150px'}} >
        <Choisir auth={{...auth, classe:devoir_cree.classe, notions:joinObj(devoir_cree.selection), titre:devoir_cree.titre, consigne:devoir_cree.comm_active, date_limit:devoir_cree.date_limit === 'Oui' ? devoir_cree.date_limit_value : false, facultatif:devoir_cree.optionnel,nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile, replayable:devoir_cree.replayable === '1' ? 0 : 1, color_btn, color_devoir}} selection={devoir_cree.selection} niveau={devoir_cree.niveau} msg={msg} setMsg={setMsg} cleanMsg={cleanMsg} updateUser={updateUser} cleanDevoir_cree={cleanDevoir_cree} setDevoir_cree={setDevoir_cree} devoir_cree={devoir_cree} />
        </div> :''
      }


      {  /*   =======================  
                  Cadre Selection  
              =======================
          */
        ((devoir_cree.etape !== 5 && Object.keys(devoir_cree.selection).length !==0)|| (devoir_cree.etape === 5 && devoir_cree.mode_aleatoire) ) && 
        <div id="selection" className="cadre_selection" align="center">
          <div align="left" className="message resultat" style={{backgroundColor:color_devoir[devoir_cree.classe]}} >
            {devoir_cree.notion.length && devoir_cree.mode_aleatoire ? <div className="eye" title="Voir un exemple de devoir aléatoire" onClick={()=>setShow_activite(true)}>👁</div> : ''}
            <div className="info_mess">{cleanDate(today)}<br/>
            {devoir_cree.date_limit === 'Oui' ? <span className="date_limit_arrow">{cleanDate(devoir_cree.date_limit_value)}</span> : ''}</div> 
            {devoir_cree.optionnel === 'Oui' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
            <div className="note_serie">{devoir_cree.classe}</div> <div className="nb_question">{devoir_cree.nb_question}Q</div> {devoir_cree.etoile === '🅳' ? <span style={{color:"steelblue", fontWeight:"bold"}} >🅳</span> : (devoir_cree.etoile || <span  style={{color:"orange"}}>Multiniveaux</span>)}
            &nbsp;
            {devoir_cree.nbEssaisMin > 1 && '(' + devoir_cree.nbEssaisMin + ' essais minimum)'}
            <br/>
            {devoir_cree.titre && <>{devoir_cree.titre} <br/></>}
            {devoir_cree.comm_active && <div style={{color:'teal', fontSize:'0.8em'}} ><em>{devoir_cree.comm_active}</em> <br/></div>}

            <hr style={{color:'lightgrey'}} />

            <div style={{color:'grey'}} >
              {Object.keys(devoir_cree.selection).map((titre, k) => <span key={k}>{devoir_cree.selection[titre][0] ? devoir_cree.selection[titre].map((soustitre, k2)=><span key={k2}>{titre}/{soustitre}<br/></span>) : titre }{!devoir_cree.selection[titre][0] ? <br/> : ''}</span>)}
            </div>

            {(Object.keys(devoir_cree.selection).length && devoir_cree.mode_aleatoire) && 
              <div align="center"><br/>
                <input className="btn standard" name="devoir_send" type="button" value="Envoyer" onClick={handleSubmit} style={{backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe], border:'2px solid '+color_btn[devoir_cree.classe]}} />
              </div>}
          </div>
        </div>
      }
      
      {msg.devoir_send ? <span dangerouslySetInnerHTML={{ __html:msg.devoir_send}}></span> : ''}
      {msg.diff_maj ? <span dangerouslySetInnerHTML={{ __html:msg.diff_maj}}></span> : ''}

        <span id="choisir0"></span>
      </div>
      



      {user.mes_devoirs.filter(dev=>dev.classe === devoir_cree.classe).length !==0 && <div id="liste_devoirs" className="content" style={{textAlign:"left", minHeight:'150px'}} >
        <h1>Mes devoirs en cours ({devoir_cree.classe})</h1>
        <div className='flex' >
         {user.mes_devoirs.map((devoir, k) => 
            (devoir.classe === devoir_cree.classe) &&
            <Etiquette key={k} user={user} auth={auth} devoir={devoir} classes={user.liste_classes} k={k} updateUsercontext={updateUsercontext} setShow_activite={setShow_activite} setDevoir_cree={setDevoir_cree}/>
          )}
        </div>
      </div>
    }

      {devoir_cree.etoile === '🅳' && <div className="content" style={{textAlign:"left", minHeight:'150px'}} >
        <h1>Différenciation des {devoir_cree.classe}</h1>
        <div name="info_diff" style={{fontSize:'1.5em', cursor:'pointer', position:'absolute', top:'30px', right:'30px'}} onClick={handleClick}>ℹ️</div>
        {devoir_cree.info_diff &&
          <div style={{border:'2px solid rgba(0,0,255,0.2)', backgroundColor:'rgba(0,0,255,0.07)', borderRadius:'10px', padding:'10px 15px'}}>
            Dans cette partie, vous pouvez affiner votre évaluation par différenciation.<br/>
            Pour cela, il suffit de cliquer sur le prénom d'un élève pour le basculer automatiquement sur le niveau suivant.<br/>
            Lorsque vous créerez un devoir, il suffira de selectionner le niveau de difficulté <span style={{color: 'steelblue', fontWight: 'bold'}}>🅳</span> pour que le programme s'occupe d'attribuer le niveau correspondant à votre choix pour chaque élève.<br/>
            ⚠️ Ne pas oublier de cliquer sur le bouton "Mettre à jour".
          </div>
        }

        <div style={{display:'flex', justifyContent:'space-around', marginBottom:'10px', fontSize:'1.2em'}}>
          <span className="teal">
            <span className="diff_cadre">Niveaux 1 : <span style={{fontSize:'1.5em'}} >⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'teal' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 1 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span> 

          <span className="chocolate">
            <span className="diff_cadre">Niveaux 2 : <span style={{fontSize:'1.5em'}} >⭑⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'chocolate' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 2 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span>

          <span className="purple">
            <span className="diff_cadre">Niveaux 3 : <span style={{fontSize:'1.5em'}} >⭑⭑⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'purple' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 3 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span>
        </div>

        <div align="center">
          <input type="button" className="btn" name="diff_maj" onClick={handleSubmit} value="Mettre à jour" />
        </div>
      </div>
    }
      </>
      : <>
          <br/><br/><br/><br/><br/>
          <div className="info"><br/> Veuillez d'abord créer une classe.<br/><br/></div>
        </>
      }
      {show_activite ? 
        <Modal auth={{...auth, profil:user.profil, notion:devoir_cree.notion, nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile ? devoir_cree.etoile : '0', activite:devoir_cree.notion.join('__'), niveau:devoir_cree.niveau, listeChoix:devoir_cree.listeChoix}} setShow_activite={setShow_activite} />
          : ''}
    </div>
  );
}